import * as React from 'react';

const styles = {
    inputBox:{
        width: '90%',
        padding: '8px 17px',
        border: '2px solid grey',
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
        borderTopRightRadius: '4px',
        borderBottomRightRadius: '4px',
    },
};

interface Props {
    columns: any[];
    onSave: (row: any[]) => any[];
    onModalClose: () => any;
    validateState: {};
    ignoreEditable: boolean;
}

interface State {
    row: any;
    fields: {};
    errors: {};
}

class SegmentInsertForm extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            row: {},
            fields: {},
            errors: {},
        };
        this.handleSaveBtnClick = this.handleSaveBtnClick.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleSaveBtnClick() {
        this.props.onSave(this.state.row);
    }

    handleValidation() {
        let fields = this.state.row;
        let errors = {};
        let formIsValid = true;

        let nameRegExp = new RegExp('^[a-z0-9A-Z_\\s]+$');

        if (!fields['displayName']){
            formIsValid = false;
            errors['displayName'] = 'Cannot be empty';
        } else if (!fields['displayName'] || !nameRegExp.test(fields['displayName'])) {
            formIsValid = false;
            errors['displayName'] = 'Please enter alphanumeric characters only';
        }

        if (!fields['name']){
            formIsValid = false;
            errors['name'] = 'Cannot be empty';
        } else if (!fields['name'] || !nameRegExp.test(fields['name'])) {
            formIsValid = false;
            errors['name'] = 'Please enter alphanumeric characters only';
        }

        this.setState({
            ...this.state,
            errors: errors,
        });

        if (formIsValid)
            this.handleSaveBtnClick();

    }

    handleChange(event){
        let fields = this.state.row;
        fields[event.target.name] = event.target.value;
        this.setState({
            ...this.state,
            row: fields,
        });
    }

    render() {
        const {
            onModalClose,
            columns,
        } = this.props;

        return (
            <div className='modal-content'>
                <h2
                    style={{
                        textAlign:'center',
                        marginTop: '40px',
                        color: '#0dc1e5',
                    }}
                >
                    Insert New Segment
                </h2>
                <div
                    style={{
                        textAlign:'center',
                        margin: '3% 10% 0',
                        color: '#e12b31',
                        fontSize: '14px',
                    }}
                >
                    Note : Please enter alphanumeric characters only. Both fields are required.</div><br/>
                <div style={{ marginLeft: '20px'}}>
                    {columns.map((column, i) => {
                        const {
                            field,
                            name,
                        } = column;

                        if (field == 'displayName' || field == 'name') {
                            return (
                                <div className='form-group' key={field}>
                                    <label>{name} : </label>
                                    <br />
                                    <input
                                        style={styles.inputBox}
                                        value={this.state.row[field]}
                                        ref={field}
                                        type='text'
                                        defaultValue={''}
                                        name={field}
                                        required
                                        onChange={this.handleChange.bind(
                                            this,
                                        )}
                                    />
                                    <br/>
                                    <span style={{ color: 'red' }}>
                                        {this.state.errors[field]}
                                    </span>
                                </div>
                            );
                        }
                    })}
                </div>
                <div>
                    <button
                        style={{
                            marginTop: '30px',
                            marginBottom: '50px',
                            marginLeft: '30%',
                        }}
                        className='btn btn-danger'
                        onClick={onModalClose}
                    >
                        Cancel
                    </button>
                    <button
                        style={{
                            marginTop: '30px',
                            marginBottom: '50px',
                            marginLeft: '5%',
                        }}
                        className='btn btn-success'
                        onClick={() => this.handleValidation()}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        );
    }
}

export default SegmentInsertForm;



// WEBPACK FOOTER //
// ./src/components/SegmentInsertForm.tsx